import { render, staticRenderFns } from "./HeaderBan.vue?vue&type=template&id=4a1bb970&scoped=true"
import script from "./HeaderBan.vue?vue&type=script&lang=js"
export * from "./HeaderBan.vue?vue&type=script&lang=js"
import style0 from "./HeaderBan.vue?vue&type=style&index=0&id=4a1bb970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1bb970",
  null
  
)

export default component.exports